import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddExpertise from "../../Modals/addExpertise";
import AddGroup from "../../Modals/addGroup";
import AddInterest from "../../Modals/addinterest";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // existing tab state
  const [valueTabs, setValueTabs] = useState(Number(searchParams.get("tab")) || 0);

  // ✅ Update tab index on query change
  useEffect(() => {
    const tab = Number(searchParams.get("tab")) || 0;
    setValueTabs(tab);
  }, [searchParams]);

  const initialTab = Number(searchParams.get("tab")) || 0;

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    navigate(`/manage-cms?tab=${newValue}`);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const [legal1, setLegal1] = useState<string>("");
  const [legal2, setLegal2] = useState<string>("");
  const [legal3, setLegal3] = useState<string>("");
  const [legal4, setLegal4] = useState<string>("");

  const [openModal, setOpenModal] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Legal" {...a11yProps(1)} />
              <Tab label="Privacy Policy" {...a11yProps(2)} />
              <Tab label="FAQ" {...a11yProps(3)} />
              <Tab label="Expertise" {...a11yProps(4)} />
              <Tab label="Interests" {...a11yProps(5)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Email Address</label>
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error && email == "" ? (
                  <h6 className="err_msg">Email is required</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                {error && phone == "" ? (
                  <h6 className="err_msg">Phone is required</h6>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setError(true);
                  if (email == "") return;
                  if (phone == "") return;
                  setError(false);
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <EditText content={legal3} setContent={setLegal3} />
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <EditText content={legal4} setContent={setLegal4} />
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal(true);
                }}
              >
                Add FAQ
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => {
                          setIsEdit(false);
                          setOpenModal(true);
                        }}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>5</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={4}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal1(true);
                }}
              >
                Add Expertise
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>Expertise title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell>Expertise title here</TableCell>

                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell>Expertise title here</TableCell>

                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4</TableCell>
                  <TableCell>Expertise title here</TableCell>

                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>5</TableCell>
                  <TableCell>Expertise title here</TableCell>

                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={5}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal3(true); // Consider renaming to setOpenInterestModal
                }}
              >
                Add Interest
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="interests table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell> Title</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>Interest title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell>Interest title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell>Interest title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4</TableCell>
                  <TableCell>Interest title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>5</TableCell>
                  <TableCell>Interest title here</TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>

      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
      <AddExpertise
        open={openModal1}
        onClose={handleCloseModal}
        setOpen={setOpenModal1}
      />
      <AddInterest
        open={openModal3}
        onClose={handleCloseModal}
        setOpen={setOpenModal3}
      />
      <AddGroup
        open={openModal2}
        onClose={handleCloseModal}
        setOpen={setOpenModal2}
      />
    </MainContainer>
  );
};

export default ManageCms;
